<!-- Large viewport -->
<div class="row w-100 d-none d-lg-flex p-0 align-items-center">
  <div class="offset-1 col-10 text-truncate d-flex">
    <div class="alert  p-1 px-3 mb-0 text-truncate workflowPlaceholder" [ngClass]="{'alert-info': !placeholder.optional, 'alert-outline-info': placeholder.optional }" role="alert">
      <span *ngIf="placeholder.optional" translate="Workflow.Placeholder.Optional"></span><span [translate]="placeholder.text"></span>
    </div>
    <span class="ms-2">
      <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" translate>Button.AddPersons</button>
      <ul class="dropdown-menu w-auto">
        <li *ngIf="showAddMyself && !placeholder.optional"><a class="dropdown-item" (click)="addMyself(placeholder.placeholderId)" translate>Button.AddMyself</a></li>
        <li><a class="dropdown-item" (click)="addPerson(placeholder.placeholderId)" translate>Button.AddPerson</a></li>
      </ul>
    </span>
  </div>
  <div *ngIf="placeholder.allowDelete" class="col-1 text-end iconbox">
    <span class="float-end">
      <div class="btn-group">
        <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-three-dots bi-large"></i>
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item pt-1 pb-1" (click)="deletePlaceholder(placeholder.placeholderId)" translate>Button.Delete</a></li>
        </ul>
      </div>
    </span>
  </div>
</div>